export default {
  verified: {
    id: 'product_page_verified',
    defaultMessage: 'Verified refurbished',
  },
  changeMind: {
    id: 'product_reassurance_change_mind',
    defaultMessage: '{day} days to change your mind',
  },
  freeReturn: {
    id: 'product_reassurance_buttons_free_return',
    defaultMessage: '{day}-days free return',
  },
}
